export const GRAPHQL_URL = 'https://based-graph.herokuapp.com/graphql';
